import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  useMediaQuery,
  Drawer,
  Box,
  styled,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import SearchIcon from '@mui/icons-material/Search';
import Dropdown from 'react-multilevel-dropdown';
import { getData } from 'utils/localStorage';
import {} from '@material-ui/core';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Searchbar } from './Searchbar';
import { Profile } from './Profile';
import { SecondaryHeader } from './SecondaryHeader';
import { MobileNav } from './MobileNav';
import { Location } from './Location';
import { localStorageKeys } from 'hooks';
import { routes } from 'routes/RouteConstants';
import { formatDistance } from 'date-fns';
import {
  SetReceiptReadStatusMutation,
  useGetNotifications,
} from '../../../query/Notifications';
import { useGetAllEquipmentData } from '../../../query/Equipmemnts';
import { useGetAllQuoteData } from '../../../query/quote';


const Navbar = ({ isSubMenu, headerRef, navRef }) => {
  const theme = useTheme();
  const isXLarge = useMediaQuery(theme.breakpoints.down('xl'));
  const isLarge = useMediaQuery(theme.breakpoints.down('lg'));
  const isMedium = useMediaQuery(theme.breakpoints.down('md'));
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isXSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const isAuth = getData(localStorageKeys.AUTH_TOKEN);
  const user = getData(localStorageKeys.USER_DETAILS);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const handleOpenFavourites = () => {
    navigate(routes.FAVOURITE_PAGE);
  };

  let userId;
  if (user && user.id) {
    userId = JSON.parse(localStorage.getItem('USER_DETAILS')).id;
  }

  // Queries
  const { data: notificationsList, refetch } = useGetNotifications();
  const { mutateAsync: SetReceiptReadStatus } = SetReceiptReadStatusMutation();
  const { data: EquipmentList } = useGetAllEquipmentData(userId, 1);
  const { data: InventoryDataResponse } = useGetAllQuoteData(userId, 1);
  const equipData = EquipmentList?.results || [];
  // State
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [navHeight, setNavHeight] = useState(headerRef?.current?.clientHeight);
  const [subnavHeight, setSubNavHeight] = useState(
    navRef?.current?.clientHeight
  );
  const [fullNavHeight, setFullNavHeight] = useState(
    parseInt(headerRef?.current?.clientHeight + navRef?.current?.clientHeight)
  );

  // Methods
  const getType = (status) => {
    if (status === 'DEPOSIT') {
      return 'pending';
    } else if (
      status === 'DEPOSIT_SUCCESSFUL' ||
      status === 'PRODUCT_ON_HOLD'
    ) {
      return 'completed';
    } else if (
      status === 'DENIED' ||
      status === 'PRODUCT_REJECTED' ||
      status === 'REMOVAL_REQUESTED'
    ) {
      return 'denied';
    } else if (status === 'AMOUNT_REFUNDED') {
      return 'denied';
    } else if (
      status === 'QUOTE_SENT' ||
      status === 'REVIEW_PENDING' ||
      status === 'INSPECTION_PENDING'
    ) {
      return 'sent';
    } else if (
      status === 'COMPLETE' ||
      status === 'PRODUCT_LISTED' ||
      status === 'PRODUCT_SOLD'
    ) {
      return 'financing';
    } else if (status === 'INSPECTION_FEE_PENDING') {
      return 'inspection_fee_pending';
    } else if (status === 'PRODUCT_REMOVED') {
      return 'remove';
    }
  };
  const TiktokIcon = ({ color = '#4d4d4d' }) => {
    return (
      <svg
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        width="29px"
        height="29px"
      >
        <path d="M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z" />
      </svg>
    );
  };

  const handleNotification = (notification) => {
    SetReceiptReadStatus(notification).then((respDData) => {
      if (respDData?.status_code === 200) {
        refetch();

        let listToAvoid = [
          'Sell my rig has requested to deposit the token amount to book your rig.',
          'You have successfully booked your rig. You can now request to finance it.',
        ];
        // Handling a bad implementation ultimately making this function also a mess
        // call the listing API filter the items in the results using notification.target_id
        // extract the data and set it to the router state while calling navigate down below...
        let listingResult = null;

        /*if(InventoryDataResponse && InventoryDataResponse.results) {
          listingResult = InventoryDataResponse.results.find((item) => {return item.id == notification.target_id});
        }*/
        if (EquipmentList && EquipmentList.results && !listingResult) {
          listingResult = EquipmentList.results.find((item) => {
            return item.id == notification.target_id;
          });
        }

        if (notification) {
          // check the target
          let redirectLink = '';
          // create a redirect link
          if (notification.target === 'listing') {
            // return;
            // redirectLink = `/accounts/Equipment-Info/:id?id=${notification.target_id}`
            if (listToAvoid.indexOf(notification.body) === -1) {
              navigate(
                `${routes.PeoductDeatils.pathname}?id=${notification.target_id}`,
                {
                  state: {
                    listing_id: notification.target_id,
                    id: listingResult?.id || null,
                    quote_status: listingResult?.status,
                    type: getType(listingResult?.status),
                    unique_id: listingResult?.unique_id,
                    isQuoteTab: false,
                    price: listingResult?.inspection_fee,
                  },
                }
              );
            } else {
              // redirect to the list page
              redirectLink = '/accounts/Equipment-Info';
            }
          }
          if (notification.target === 'finance') {
            redirectLink = `/financing-detail?id=${notification.target_id}`;
          }
          // Handle Notification Read API Call
          // setReceiptReadStatusMutation({id: notification.id});
          // check the sub_target
          // redirect the user - using the generated redirect link
          window.location.assign(redirectLink);
          // hide the notification panel
          setShowNotifications(false);
        }
      }
    });
  };

  // Components

  const NothingToShow = () => {
    return (
      <svg
        width="187"
        height="144"
        viewBox="0 0 187 144"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.703 14.0909H20.2864L22.774 18.7891H22.8805L25.3681 14.0909H27.9516L23.9725 21.1435V25H21.682V21.1435L17.703 14.0909ZM31.1516 25.1598C30.3242 25.1598 29.6086 24.984 29.0049 24.6325C28.4048 24.2773 27.9414 23.7837 27.6147 23.1516C27.288 22.516 27.1246 21.7791 27.1246 20.9411C27.1246 20.0959 27.288 19.3572 27.6147 18.7251C27.9414 18.0895 28.4048 17.5959 29.0049 17.2443C29.6086 16.8892 30.3242 16.7116 31.1516 16.7116C31.979 16.7116 32.6928 16.8892 33.2929 17.2443C33.8966 17.5959 34.3618 18.0895 34.6885 18.7251C35.0152 19.3572 35.1786 20.0959 35.1786 20.9411C35.1786 21.7791 35.0152 22.516 34.6885 23.1516C34.3618 23.7837 33.8966 24.2773 33.2929 24.6325C32.6928 24.984 31.979 25.1598 31.1516 25.1598ZM31.1622 23.402C31.5387 23.402 31.8529 23.2955 32.1051 23.0824C32.3572 22.8658 32.5472 22.571 32.675 22.1982C32.8064 21.8253 32.8721 21.4009 32.8721 20.9251C32.8721 20.4492 32.8064 20.0249 32.675 19.652C32.5472 19.2791 32.3572 18.9844 32.1051 18.7678C31.8529 18.5511 31.5387 18.4428 31.1622 18.4428C30.7823 18.4428 30.4627 18.5511 30.2034 18.7678C29.9478 18.9844 29.7542 19.2791 29.6228 19.652C29.495 20.0249 29.4311 20.4492 29.4311 20.9251C29.4311 21.4009 29.495 21.8253 29.6228 22.1982C29.7542 22.571 29.9478 22.8658 30.2034 23.0824C30.4627 23.2955 30.7823 23.402 31.1622 23.402ZM41.9009 21.5163V16.8182H44.1701V25H41.9914V23.5138H41.9062C41.7215 23.9933 41.4144 24.3786 40.9847 24.6697C40.5585 24.9609 40.0383 25.1065 39.424 25.1065C38.8771 25.1065 38.3959 24.9822 37.9804 24.7337C37.5649 24.4851 37.24 24.1317 37.0056 23.6737C36.7748 23.2156 36.6576 22.6669 36.6541 22.0277V16.8182H38.9233V21.6229C38.9268 22.1058 39.0564 22.4876 39.3121 22.7681C39.5678 23.0487 39.9105 23.1889 40.3402 23.1889C40.6136 23.1889 40.8693 23.1268 41.1072 23.0025C41.3451 22.8746 41.5369 22.6864 41.6825 22.4379C41.8316 22.1893 41.9044 21.8821 41.9009 21.5163ZM51.7899 25.1545C51.2679 25.1545 50.8027 25.0639 50.3943 24.8828C49.9859 24.6982 49.6628 24.4265 49.4248 24.0678C49.1905 23.7056 49.0733 23.2546 49.0733 22.7148C49.0733 22.2603 49.1567 21.8786 49.3236 21.5696C49.4905 21.2607 49.7178 21.0121 50.0055 20.8239C50.2931 20.6357 50.6198 20.4936 50.9856 20.3977C51.3549 20.3018 51.742 20.2344 52.1468 20.1953C52.6226 20.1456 53.0062 20.0994 53.2974 20.0568C53.5886 20.0107 53.7998 19.9432 53.9312 19.8544C54.0626 19.7656 54.1283 19.6342 54.1283 19.4602V19.4283C54.1283 19.0909 54.0218 18.8299 53.8087 18.6452C53.5992 18.4606 53.3009 18.3683 52.9138 18.3683C52.5055 18.3683 52.1805 18.4588 51.9391 18.6399C51.6976 18.8175 51.5378 19.0412 51.4597 19.3111L49.3609 19.1406C49.4675 18.6435 49.677 18.2138 49.9895 17.8516C50.302 17.4858 50.705 17.2053 51.1986 17.0099C51.6958 16.8111 52.2711 16.7116 52.9245 16.7116C53.379 16.7116 53.8141 16.7649 54.2295 16.8714C54.6486 16.978 55.0197 17.1431 55.3428 17.3668C55.6695 17.5906 55.927 17.8782 56.1152 18.2298C56.3034 18.5778 56.3975 18.995 56.3975 19.4815V25H54.2455V23.8654H54.1816C54.0502 24.1211 53.8744 24.3466 53.6543 24.5419C53.4341 24.7337 53.1695 24.8846 52.8606 24.9947C52.5516 25.1012 52.1947 25.1545 51.7899 25.1545ZM52.4398 23.5884C52.7736 23.5884 53.0683 23.5227 53.324 23.3913C53.5797 23.2564 53.7803 23.0753 53.9259 22.848C54.0715 22.6207 54.1443 22.3633 54.1443 22.0756V21.2074C54.0733 21.2536 53.9756 21.2962 53.8513 21.3352C53.7306 21.3707 53.5939 21.4045 53.4412 21.4364C53.2885 21.4648 53.1358 21.4915 52.9831 21.5163C52.8304 21.5376 52.6919 21.5572 52.5676 21.5749C52.3013 21.614 52.0687 21.6761 51.8698 21.7614C51.6709 21.8466 51.5165 21.962 51.4064 22.1076C51.2963 22.2496 51.2413 22.4272 51.2413 22.6403C51.2413 22.9492 51.3531 23.1854 51.5768 23.3487C51.8041 23.5085 52.0918 23.5884 52.4398 23.5884ZM58.158 25V16.8182H60.3579V18.2457H60.4431C60.5923 17.7379 60.8426 17.3544 61.1942 17.0952C61.5458 16.8324 61.9506 16.701 62.4087 16.701C62.5223 16.701 62.6448 16.7081 62.7762 16.7223C62.9076 16.7365 63.023 16.756 63.1225 16.7809V18.7944C63.0159 18.7624 62.8686 18.734 62.6804 18.7092C62.4921 18.6843 62.3199 18.6719 62.1637 18.6719C61.8299 18.6719 61.5316 18.7447 61.2688 18.8903C61.0095 19.0323 60.8036 19.2312 60.6509 19.4869C60.5017 19.7425 60.4272 20.0373 60.4272 20.3711V25H58.158ZM67.6435 25.1598C66.8019 25.1598 66.0775 24.9893 65.4702 24.6484C64.8665 24.304 64.4013 23.8175 64.0746 23.1889C63.7479 22.5568 63.5846 21.8093 63.5846 20.9464C63.5846 20.1048 63.7479 19.3661 64.0746 18.7305C64.4013 18.0948 64.8612 17.5994 65.4542 17.2443C66.0508 16.8892 66.7504 16.7116 67.553 16.7116C68.0927 16.7116 68.5952 16.7987 69.0604 16.9727C69.5292 17.1431 69.9375 17.4006 70.2856 17.745C70.6371 18.0895 70.9106 18.5227 71.1059 19.0447C71.3012 19.5632 71.3988 20.1705 71.3988 20.8665V21.4897H64.4901V20.0835H69.2628C69.2628 19.7567 69.1918 19.4673 69.0498 19.2152C68.9077 18.9631 68.7106 18.766 68.4585 18.6239C68.2099 18.4783 67.9205 18.4055 67.5902 18.4055C67.2458 18.4055 66.9404 18.4854 66.6741 18.6452C66.4113 18.8015 66.2053 19.0128 66.0562 19.2791C65.907 19.5419 65.8307 19.8349 65.8271 20.158V21.495C65.8271 21.8999 65.9017 22.2496 66.0508 22.5444C66.2035 22.8391 66.4184 23.0664 66.6954 23.2262C66.9723 23.386 67.3008 23.4659 67.6808 23.4659C67.9329 23.4659 68.1638 23.4304 68.3733 23.3594C68.5828 23.2884 68.7621 23.1818 68.9113 23.0398C69.0604 22.8977 69.1741 22.7237 69.2522 22.5178L71.3509 22.6562C71.2444 23.1605 71.026 23.6009 70.6957 23.9773C70.369 24.3501 69.9464 24.6413 69.428 24.8509C68.913 25.0568 68.3182 25.1598 67.6435 25.1598ZM78.6844 25.1545C78.1624 25.1545 77.6972 25.0639 77.2888 24.8828C76.8805 24.6982 76.5573 24.4265 76.3194 24.0678C76.085 23.7056 75.9678 23.2546 75.9678 22.7148C75.9678 22.2603 76.0513 21.8786 76.2182 21.5696C76.3851 21.2607 76.6123 21.0121 76.9 20.8239C77.1876 20.6357 77.5143 20.4936 77.8801 20.3977C78.2494 20.3018 78.6365 20.2344 79.0413 20.1953C79.5172 20.1456 79.9007 20.0994 80.1919 20.0568C80.4831 20.0107 80.6944 19.9432 80.8258 19.8544C80.9572 19.7656 81.0229 19.6342 81.0229 19.4602V19.4283C81.0229 19.0909 80.9163 18.8299 80.7033 18.6452C80.4937 18.4606 80.1954 18.3683 79.8084 18.3683C79.4 18.3683 79.0751 18.4588 78.8336 18.6399C78.5921 18.8175 78.4323 19.0412 78.3542 19.3111L76.2555 19.1406C76.362 18.6435 76.5715 18.2138 76.884 17.8516C77.1965 17.4858 77.5996 17.2053 78.0932 17.0099C78.5903 16.8111 79.1656 16.7116 79.819 16.7116C80.2736 16.7116 80.7086 16.7649 81.1241 16.8714C81.5431 16.978 81.9142 17.1431 82.2373 17.3668C82.5641 17.5906 82.8215 17.8782 83.0097 18.2298C83.1979 18.5778 83.292 18.995 83.292 19.4815V25H81.14V23.8654H81.0761C80.9447 24.1211 80.769 24.3466 80.5488 24.5419C80.3286 24.7337 80.0641 24.8846 79.7551 24.9947C79.4462 25.1012 79.0893 25.1545 78.6844 25.1545ZM79.3343 23.5884C79.6681 23.5884 79.9628 23.5227 80.2185 23.3913C80.4742 23.2564 80.6748 23.0753 80.8204 22.848C80.966 22.6207 81.0388 22.3633 81.0388 22.0756V21.2074C80.9678 21.2536 80.8702 21.2962 80.7459 21.3352C80.6251 21.3707 80.4884 21.4045 80.3357 21.4364C80.183 21.4648 80.0303 21.4915 79.8776 21.5163C79.7249 21.5376 79.5864 21.5572 79.4621 21.5749C79.1958 21.614 78.9632 21.6761 78.7643 21.7614C78.5655 21.8466 78.411 21.962 78.3009 22.1076C78.1908 22.2496 78.1358 22.4272 78.1358 22.6403C78.1358 22.9492 78.2476 23.1854 78.4714 23.3487C78.6986 23.5085 78.9863 23.5884 79.3343 23.5884ZM87.3217 14.0909V25H85.0525V14.0909H87.3217ZM91.4086 14.0909V25H89.1394V14.0909H91.4086ZM100.395 25.1598C99.5567 25.1598 98.8358 24.9822 98.2321 24.6271C97.632 24.2685 97.1703 23.7713 96.8472 23.1357C96.5276 22.5 96.3678 21.7685 96.3678 20.9411C96.3678 20.103 96.5293 19.3679 96.8525 18.7358C97.1792 18.1001 97.6426 17.6048 98.2428 17.2496C98.8429 16.891 99.5567 16.7116 100.384 16.7116C101.098 16.7116 101.723 16.8413 102.259 17.1005C102.795 17.3597 103.22 17.7237 103.532 18.1925C103.845 18.6612 104.017 19.2116 104.049 19.8438H101.908C101.847 19.4354 101.687 19.1069 101.428 18.8583C101.172 18.6062 100.837 18.4801 100.421 18.4801C100.07 18.4801 99.7627 18.576 99.4999 18.7678C99.2406 18.956 99.0382 19.2312 98.8926 19.5934C98.747 19.9556 98.6742 20.3942 98.6742 20.9091C98.6742 21.4311 98.7453 21.875 98.8873 22.2408C99.0329 22.6065 99.2371 22.8853 99.4999 23.0771C99.7627 23.2688 100.07 23.3647 100.421 23.3647C100.681 23.3647 100.913 23.3114 101.119 23.2049C101.329 23.0984 101.501 22.9439 101.636 22.7415C101.774 22.5355 101.865 22.2887 101.908 22.0011H104.049C104.013 22.6261 103.843 23.1765 103.538 23.6523C103.236 24.1246 102.818 24.494 102.286 24.7603C101.753 25.0266 101.123 25.1598 100.395 25.1598ZM107.835 25.1545C107.313 25.1545 106.848 25.0639 106.439 24.8828C106.031 24.6982 105.708 24.4265 105.47 24.0678C105.235 23.7056 105.118 23.2546 105.118 22.7148C105.118 22.2603 105.202 21.8786 105.369 21.5696C105.535 21.2607 105.763 21.0121 106.05 20.8239C106.338 20.6357 106.665 20.4936 107.03 20.3977C107.4 20.3018 107.787 20.2344 108.192 20.1953C108.668 20.1456 109.051 20.0994 109.342 20.0568C109.633 20.0107 109.845 19.9432 109.976 19.8544C110.108 19.7656 110.173 19.6342 110.173 19.4602V19.4283C110.173 19.0909 110.067 18.8299 109.854 18.6452C109.644 18.4606 109.346 18.3683 108.959 18.3683C108.55 18.3683 108.225 18.4588 107.984 18.6399C107.742 18.8175 107.583 19.0412 107.505 19.3111L105.406 19.1406C105.512 18.6435 105.722 18.2138 106.034 17.8516C106.347 17.4858 106.75 17.2053 107.244 17.0099C107.741 16.8111 108.316 16.7116 108.969 16.7116C109.424 16.7116 109.859 16.7649 110.274 16.8714C110.693 16.978 111.065 17.1431 111.388 17.3668C111.714 17.5906 111.972 17.8782 112.16 18.2298C112.348 18.5778 112.442 18.995 112.442 19.4815V25H110.29V23.8654H110.227C110.095 24.1211 109.919 24.3466 109.699 24.5419C109.479 24.7337 109.214 24.8846 108.905 24.9947C108.597 25.1012 108.24 25.1545 107.835 25.1545ZM108.485 23.5884C108.818 23.5884 109.113 23.5227 109.369 23.3913C109.625 23.2564 109.825 23.0753 109.971 22.848C110.116 22.6207 110.189 22.3633 110.189 22.0756V21.2074C110.118 21.2536 110.021 21.2962 109.896 21.3352C109.776 21.3707 109.639 21.4045 109.486 21.4364C109.333 21.4648 109.181 21.4915 109.028 21.5163C108.875 21.5376 108.737 21.5572 108.613 21.5749C108.346 21.614 108.114 21.6761 107.915 21.7614C107.716 21.8466 107.561 21.962 107.451 22.1076C107.341 22.2496 107.286 22.4272 107.286 22.6403C107.286 22.9492 107.398 23.1854 107.622 23.3487C107.849 23.5085 108.137 23.5884 108.485 23.5884ZM119.45 21.5163V16.8182H121.719V25H119.54V23.5138H119.455C119.27 23.9933 118.963 24.3786 118.534 24.6697C118.107 24.9609 117.587 25.1065 116.973 25.1065C116.426 25.1065 115.945 24.9822 115.529 24.7337C115.114 24.4851 114.789 24.1317 114.554 23.6737C114.324 23.2156 114.206 22.6669 114.203 22.0277V16.8182H116.472V21.6229C116.476 22.1058 116.605 22.4876 116.861 22.7681C117.117 23.0487 117.459 23.1889 117.889 23.1889C118.162 23.1889 118.418 23.1268 118.656 23.0025C118.894 22.8746 119.086 22.6864 119.231 22.4379C119.38 22.1893 119.453 21.8821 119.45 21.5163ZM127.22 28.2386C126.485 28.2386 125.855 28.1374 125.329 27.935C124.807 27.7362 124.392 27.4645 124.083 27.12C123.774 26.7756 123.573 26.3885 123.481 25.9588L125.579 25.6765C125.643 25.8398 125.745 25.9925 125.883 26.1346C126.022 26.2766 126.204 26.3903 126.432 26.4755C126.663 26.5643 126.943 26.6087 127.273 26.6087C127.767 26.6087 128.174 26.4879 128.493 26.2464C128.816 26.0085 128.978 25.609 128.978 25.0479V23.5511H128.882C128.783 23.7784 128.633 23.9933 128.435 24.1957C128.236 24.3981 127.98 24.5632 127.667 24.6911C127.355 24.8189 126.982 24.8828 126.549 24.8828C125.935 24.8828 125.375 24.7408 124.871 24.4567C124.37 24.169 123.971 23.7305 123.672 23.141C123.378 22.5479 123.23 21.7987 123.23 20.8931C123.23 19.9663 123.381 19.1921 123.683 18.5707C123.985 17.9492 124.386 17.484 124.887 17.1751C125.391 16.8661 125.943 16.7116 126.544 16.7116C127.002 16.7116 127.385 16.7898 127.694 16.946C128.003 17.0987 128.252 17.2905 128.44 17.5213C128.632 17.7486 128.779 17.9723 128.882 18.1925H128.967V16.8182H131.22V25.0799C131.22 25.7759 131.05 26.3583 130.709 26.8271C130.368 27.2958 129.896 27.6474 129.292 27.8817C128.692 28.1197 128.001 28.2386 127.22 28.2386ZM127.268 23.1783C127.634 23.1783 127.943 23.0877 128.195 22.9066C128.451 22.7219 128.646 22.4592 128.781 22.1183C128.919 21.7738 128.989 21.3619 128.989 20.8825C128.989 20.4031 128.921 19.9876 128.786 19.636C128.651 19.2809 128.456 19.0057 128.2 18.8104C127.944 18.6151 127.634 18.5174 127.268 18.5174C126.895 18.5174 126.581 18.6186 126.325 18.821C126.069 19.0199 125.876 19.2969 125.745 19.652C125.613 20.0071 125.547 20.4173 125.547 20.8825C125.547 21.3548 125.613 21.7631 125.745 22.1076C125.879 22.4485 126.073 22.7131 126.325 22.9013C126.581 23.0859 126.895 23.1783 127.268 23.1783ZM135.295 20.2699V25H133.026V14.0909H135.231V18.2617H135.327C135.512 17.7788 135.81 17.4006 136.222 17.1271C136.634 16.8501 137.151 16.7116 137.772 16.7116C138.34 16.7116 138.836 16.8359 139.258 17.0845C139.685 17.3295 140.015 17.6829 140.249 18.1445C140.487 18.6026 140.604 19.1513 140.601 19.7905V25H138.332V20.1953C138.335 19.6911 138.207 19.2987 137.948 19.0181C137.692 18.7376 137.334 18.5973 136.872 18.5973C136.563 18.5973 136.29 18.663 136.052 18.7944C135.817 18.9258 135.633 19.1175 135.498 19.3697C135.366 19.6183 135.299 19.9183 135.295 20.2699ZM146.738 16.8182V18.5227H141.811V16.8182H146.738ZM142.93 14.858H145.199V22.4858C145.199 22.6953 145.231 22.8587 145.295 22.9759C145.359 23.0895 145.448 23.1694 145.561 23.2156C145.678 23.2617 145.813 23.2848 145.966 23.2848C146.073 23.2848 146.179 23.2759 146.286 23.2582C146.392 23.2369 146.474 23.2209 146.531 23.2102L146.888 24.8988C146.774 24.9343 146.614 24.9751 146.408 25.0213C146.202 25.071 145.952 25.1012 145.657 25.1119C145.11 25.1332 144.631 25.0604 144.219 24.8935C143.811 24.7266 143.493 24.4673 143.265 24.1158C143.038 23.7642 142.926 23.3203 142.93 22.7841V14.858ZM156.935 21.5163V16.8182H159.204V25H157.026V23.5138H156.94C156.756 23.9933 156.449 24.3786 156.019 24.6697C155.593 24.9609 155.072 25.1065 154.458 25.1065C153.911 25.1065 153.43 24.9822 153.015 24.7337C152.599 24.4851 152.274 24.1317 152.04 23.6737C151.809 23.2156 151.692 22.6669 151.688 22.0277V16.8182H153.957V21.6229C153.961 22.1058 154.091 22.4876 154.346 22.7681C154.602 23.0487 154.945 23.1889 155.374 23.1889C155.648 23.1889 155.903 23.1268 156.141 23.0025C156.379 22.8746 156.571 22.6864 156.717 22.4379C156.866 22.1893 156.939 21.8821 156.935 21.5163ZM161.019 28.0682V16.8182H163.257V18.1925H163.358C163.457 17.9723 163.601 17.7486 163.789 17.5213C163.981 17.2905 164.23 17.0987 164.535 16.946C164.844 16.7898 165.227 16.7116 165.686 16.7116C166.282 16.7116 166.833 16.8679 167.337 17.1804C167.841 17.4893 168.244 17.9563 168.546 18.5813C168.848 19.2028 168.999 19.9822 168.999 20.9197C168.999 21.8324 168.851 22.603 168.557 23.2315C168.265 23.8565 167.868 24.3306 167.363 24.6538C166.863 24.9734 166.302 25.1332 165.68 25.1332C165.24 25.1332 164.865 25.0604 164.556 24.9148C164.251 24.7692 164 24.5863 163.805 24.3661C163.61 24.1424 163.461 23.9169 163.358 23.6896H163.288V28.0682H161.019ZM163.241 20.9091C163.241 21.3956 163.308 21.82 163.443 22.1822C163.578 22.5444 163.773 22.8267 164.029 23.0291C164.285 23.228 164.595 23.3274 164.961 23.3274C165.33 23.3274 165.643 23.2262 165.899 23.0238C166.154 22.8178 166.348 22.5337 166.479 22.1715C166.614 21.8058 166.682 21.3849 166.682 20.9091C166.682 20.4368 166.616 20.0213 166.485 19.6626C166.353 19.304 166.16 19.0234 165.904 18.821C165.648 18.6186 165.334 18.5174 164.961 18.5174C164.592 18.5174 164.279 18.6151 164.024 18.8104C163.771 19.0057 163.578 19.2827 163.443 19.6413C163.308 20 163.241 20.4226 163.241 20.9091Z"
          fill="#0C4B74"
        />
        <path
          d="M138.853 85.923C138.853 96.6301 135.357 106.477 129.559 114.434C126.331 118.703 122.472 122.486 118.05 125.427C110.877 130.251 102.319 133.097 93.1178 133.097C67.8135 133.097 47.386 111.97 47.386 86.0185C47.386 59.972 67.9052 38.94 93.1178 38.94C102.319 38.94 110.877 41.7767 118.05 46.5142C122.472 49.456 126.331 53.2383 129.559 57.5078C135.443 65.3685 138.853 75.216 138.853 85.923Z"
          fill="#F5F5F5"
        />
        <path
          opacity="0.3"
          d="M129.559 57.4122V114.338C126.331 118.608 122.472 122.39 118.05 125.332H71.5852V54.1934C71.6779 52.1017 72.506 50.2104 73.7935 48.8828C75.2663 47.3737 77.1986 46.5141 79.4069 46.5141H118.05C122.472 49.4559 126.426 53.1523 129.559 57.4122Z"
          fill="#EDEDED"
        />
        <path
          d="M121.183 56.6576H95.0501V46.5141H129.368C129.464 46.5141 129.559 46.5141 129.559 46.5141C134.889 46.6096 139.216 51.1561 139.216 56.7436H127.897"
          fill="#EDEDED"
        />
        <path
          d="M130.294 46.5141C128.27 46.6096 126.426 47.5552 125.051 48.8828C124.955 48.9783 124.774 49.1693 124.678 49.3604C123.484 50.7835 122.653 52.6747 122.653 54.6614V115.284C122.653 120.976 118.241 125.523 112.716 125.523H64.501V54.1934C64.5927 52.1017 65.4208 50.2104 66.7093 48.8828C68.1812 47.3737 70.1134 46.5141 72.3216 46.5141H120.724H129.922C130.103 46.5141 130.199 46.5141 130.294 46.5141Z"
          fill="white"
        />
        <path
          d="M112.992 60.3444H98.7302C98.1781 60.3444 97.8104 59.8764 97.8104 59.3988C97.8104 58.9308 98.2698 58.4532 98.7302 58.4532H113.085C113.637 58.4532 114.005 58.9308 114.005 59.3988C114.005 59.8764 113.544 60.3444 112.992 60.3444Z"
          fill="#EDEDED"
        />
        <path
          d="M92.0128 60.3444H73.3342C72.7821 60.3444 72.4144 59.8764 72.4144 59.3988C72.4144 58.9308 72.8738 58.4532 73.3342 58.4532H92.0128C92.5649 58.4532 92.9336 58.9308 92.9336 59.3988C92.9336 59.8764 92.5649 60.3444 92.0128 60.3444Z"
          fill="#EDEDED"
        />
        <path
          d="M103.975 69.9146H85.3879C84.8358 69.9146 84.4681 69.437 84.4681 68.969C84.4681 68.3959 84.9285 68.0235 85.3879 68.0235H103.975C104.527 68.0235 104.896 68.4915 104.896 68.969C104.896 69.5326 104.527 69.9146 103.975 69.9146Z"
          fill="#EDEDED"
        />
        <path
          d="M79.407 69.9146H73.3342C72.7821 69.9146 72.4144 69.437 72.4144 68.969C72.4144 68.3959 72.8738 68.0235 73.3342 68.0235H79.407C79.959 68.0235 80.3277 68.4915 80.3277 68.969C80.3277 69.5326 79.8673 69.9146 79.407 69.9146Z"
          fill="#E3E3E3"
        />
        <path
          d="M112.992 79.5797H101.582C101.03 79.5797 100.662 79.1021 100.662 78.6246C100.662 78.061 101.123 77.679 101.582 77.679H112.992C113.544 77.679 113.913 78.1565 113.913 78.6246C114.005 79.1021 113.544 79.5797 112.992 79.5797Z"
          fill="#E3E3E3"
        />
        <path
          d="M96.1543 79.5797H73.3342C72.7821 79.5797 72.4144 79.1021 72.4144 78.6246C72.4144 78.061 72.8738 77.679 73.3342 77.679H96.1543C96.7063 77.679 97.0741 78.1565 97.0741 78.6246C97.0741 79.1021 96.7063 79.5797 96.1543 79.5797Z"
          fill="#EDEDED"
        />
        <path
          d="M103.975 89.1422H91.3689C90.8169 89.1422 90.4491 88.6741 90.4491 88.1966C90.4491 87.719 90.9086 87.251 91.3689 87.251H103.975C104.527 87.251 104.896 87.719 104.896 88.1966C104.896 88.6741 104.527 89.1422 103.975 89.1422Z"
          fill="#EDEDED"
        />
        <path
          d="M85.94 89.1422H73.3342C72.7821 89.1422 72.4144 88.6741 72.4144 88.1966C72.4144 87.719 72.8738 87.251 73.3342 87.251H85.94C86.4921 87.251 86.8608 87.719 86.8608 88.1966C86.8608 88.6741 86.4921 89.1422 85.94 89.1422Z"
          fill="#E3E3E3"
        />
        <path
          d="M112.992 98.8076H104.251C103.699 98.8076 103.331 98.33 103.331 97.862C103.331 97.2889 103.791 96.9069 104.251 96.9069H112.992C113.544 96.9069 113.913 97.3845 113.913 97.862C114.005 98.33 113.544 98.8076 112.992 98.8076Z"
          fill="#EDEDED"
        />
        <path
          d="M98.5468 98.8076H83.8244C83.2723 98.8076 82.9037 98.33 82.9037 97.862C82.9037 97.2889 83.364 96.9069 83.8244 96.9069H98.5468C99.0989 96.9069 99.4666 97.3845 99.4666 97.862C99.5583 98.33 99.0989 98.8076 98.5468 98.8076Z"
          fill="#E3E3E3"
        />
        <path
          d="M78.3953 98.8076H73.2424C72.6904 98.8076 72.3216 98.33 72.3216 97.862C72.3216 97.2889 72.7821 96.9069 73.2424 96.9069H78.3953C78.9474 96.9069 79.3152 97.3845 79.3152 97.862C79.3152 98.33 78.9474 98.8076 78.3953 98.8076Z"
          fill="#EDEDED"
        />
        <path
          d="M103.975 108.377H95.2335C94.6815 108.377 94.3137 107.9 94.3137 107.422C94.3137 106.954 94.7741 106.477 95.2335 106.477H103.975C104.527 106.477 104.896 106.954 104.896 107.422C104.896 107.9 104.527 108.377 103.975 108.377Z"
          fill="#EDEDED"
        />
        <path
          d="M89.5285 108.377H73.3342C72.7821 108.377 72.4144 107.9 72.4144 107.422C72.4144 106.954 72.8738 106.477 73.3342 106.477H89.5285C90.0806 106.477 90.4492 106.954 90.4492 107.422C90.4492 107.9 89.9889 108.377 89.5285 108.377Z"
          fill="#E3E3E3"
        />
        <path
          d="M91.5534 117.375H104.251C104.251 119.553 105.079 121.635 106.552 123.058C107.932 124.481 109.864 125.427 112.073 125.427H54.7473C52.6307 125.427 50.6068 124.567 49.2266 123.058C47.8465 121.635 46.9257 119.648 46.9257 117.375H84.5599C84.6526 117.375 91.6451 117.471 91.5534 117.375Z"
          fill="#EDEDED"
        />
        <path
          d="M55.561 48.8731C56.7693 48.4623 57.4303 47.1347 57.0377 45.8835C56.6442 44.6418 55.3471 43.9637 54.1388 44.3648C52.9306 44.766 52.2697 46.1032 52.6622 47.3544C53.0548 48.5961 54.3528 49.2742 55.561 48.8731Z"
          fill="#CCCCCC"
        />
        <path
          d="M60.5822 41.1458C61.4036 40.8688 61.8535 39.9614 61.586 39.1113C61.3196 38.2708 60.437 37.8028 59.6156 38.0798C58.7932 38.3568 58.3443 39.2642 58.6108 40.1143C58.8782 40.9548 59.7608 41.4227 60.5822 41.1458Z"
          fill="#CCCCCC"
        />
        <path
          d="M39.5645 92.1788C40.4289 92.1788 41.129 91.4528 41.129 90.5646C41.129 89.6763 40.4289 88.9505 39.5645 88.9505C38.7011 88.9505 38 89.6763 38 90.5646C38 91.4528 38.7011 92.1788 39.5645 92.1788Z"
          fill="#05945B"
        />
        <path
          d="M148.289 72.206C149.712 70.8689 149.808 68.5861 148.509 67.1152C147.21 65.6539 144.994 65.5487 143.571 66.8954C142.148 68.2326 142.043 70.5059 143.351 71.9768C144.65 73.4477 146.866 73.5432 148.289 72.206Z"
          fill="#CCCCCC"
        />
        <path
          d="M147.592 56.4668C148.404 56.4668 149.063 55.7887 149.063 54.9482C149.063 54.1077 148.404 53.4294 147.592 53.4294C146.78 53.4294 146.121 54.1077 146.121 54.9482C146.121 55.7887 146.78 56.4668 147.592 56.4668Z"
          fill="#DC2804"
        />
        <g filter="url(#filter0_d_1_47)">
          <path
            d="M67.7014 69.869C67.7981 72.9937 65.1782 75.6502 61.9762 75.7458H60.424L56.1543 75.8413C49.7503 76.0324 44.4128 71.0062 44.2184 64.7568C44.1217 58.4979 49.1681 53.29 55.5721 53.0989C61.9762 52.9078 67.3136 57.934 67.507 64.1834L67.6047 66.5533L67.7014 69.869Z"
            fill="#0F5E91"
          />
        </g>
        <path
          d="M54.1026 69.1601C53.7349 69.1601 53.3672 69.0646 53.0911 68.778L50.4225 66.0272C49.8704 65.4637 49.8704 64.6136 50.4225 64.0405C50.9746 63.4769 51.8027 63.4769 52.3547 64.0405L54.0109 65.7502L58.8878 60.7262C59.4399 60.1531 60.268 60.1531 60.8201 60.7262C61.3721 61.2897 61.3721 62.1494 60.8201 62.7129L54.9308 68.778C54.8391 68.969 54.4713 69.1601 54.1026 69.1601Z"
          fill="white"
        />
        <g filter="url(#filter1_d_1_47)">
          <path
            d="M147.354 117.47C147.064 118.719 146.685 119.871 146.197 121.023C146.107 121.304 146.007 121.497 145.818 121.788C144.183 124.954 141.59 127.548 138.419 129.088C138.04 129.272 137.652 129.465 137.362 129.562C134.291 130.811 130.831 131.295 127.371 130.52C118.247 128.603 112.387 119.677 114.309 110.558C116.23 101.428 125.167 95.5714 134.291 97.4979C137.552 98.1659 140.433 99.802 142.837 102.106C146.775 106.134 148.51 111.894 147.354 117.47Z"
            fill="#FFC200"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_1_47"
            x="36.2171"
            y="50.0936"
            width="39.4869"
            height="38.753"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.859467 0 0 0 0 0.832639 0 0 0 0 0.916667 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1_47"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1_47"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_1_47"
            x="105.944"
            y="94.1312"
            width="49.7625"
            height="49.7625"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="5" />
            <feGaussianBlur stdDeviation="4" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0 0 0 0 0.2 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_1_47"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_1_47"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  };

  // Hooks
  useEffect(() => {
    setNavHeight(headerRef?.current?.clientHeight);
  }, [headerRef?.current?.clientHeight, location.pathname]);

  useEffect(() => {
    setFullNavHeight(
      isMedium
        ? 40
        : parseInt(
            headerRef?.current?.clientHeight + navRef?.current?.clientHeight
          )
    );
  }, [setFullNavHeight?.current?.clientHeight, location.pathname]);

  useEffect(() => {
    /*setNotifications({
      'pagination_option': {
        'total': 30,
        'pages': 1,
        'page': 1,
        'per_page': 30
      },
      'results': [
        {
          'id': 1904,
          'created_at': '2023-05-28T15:06:35.849348Z',
          'title': 'Sell My Rig',
          'body': 'You have successfully booked your rig. You can now request to finance it.',
          'image': null,
          'target': 'listing',
          'sub_target': null,
          'target_id': '420',
          'read_receipt': false
        },
        {
          'id': 1903,
          'created_at': '2023-05-28T15:05:25.656289Z',
          'title': 'Sell My Rig',
          'body': 'Sell my rig has requested to deposit the token amount to book your rig.',
          'image': null,
          'target': 'listing',
          'sub_target': 'payment',
          'target_id': '420',
          'read_receipt': false
        },
        {
          'id': 397,
          'created_at': '2023-05-11T06:38:24.875258Z',
          'title': 'Sell My Rig',
          'body': 'We have started to reveiw your listing. A team member will reach out to you shortly for further instructions and if more information is required.',
          'image': null,
          'target': 'listing',
          'sub_target': null,
          'target_id': '527',
          'read_receipt': false
        },
        {
          'id': 396,
          'created_at': '2023-05-10T10:44:15.571275Z',
          'title': 'Sell My Rig',
          'body': 'We have started to reveiw your listing. A team member will reach out to you shortly for further instructions and if more information is required.',
          'image': null,
          'target': 'listing',
          'sub_target': null,
          'target_id': '526',
          'read_receipt': false
        },
      ]
    })*/

    // call the notifications API
    if (notificationsList) {
      setNotifications(notificationsList?.results);
    }

    setTimeout(() => {}, 1000);
  }, [notificationsList]);

  return (
    <>
      <Box
        sx={{
          zIndex: '50 !important',
          boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.08)',
        }}
        container
        className=" !fixed top-0 text-align: center;
     left-[50%]
    -translate-x-[50%] !justify-center w-full   !bg-white"
        justifyContent="center"
      >
        <Box
          ref={headerRef}
          sx={{ position: 'sticky', top: '0', maxWidth: '1700px' }}
          className={`py-[18px]  flex sticky items-center max-w-[1700px] top-0 ${
            isLarge ? 'bg-white' : 'bg-white'
          } ${isMedium ? '!px-4' : '!px-[92px]'} m-auto`}
          alignItems="center"
          justifyContent={isLarge == 'false' ? 'center' : 'space-between'}
          // sx={{ zIndex: 2 }}
        >
          <Box
            item
            container
            className={`flex items-center !max-w-[50%] ${
              isSmall && ' !w-[90%]'
            } `}
            justifyContent="left"
          >
            <Box
              className={` relative flex items-center ${
                isSmall || isXSmall ? '!p-0 !px-2' : '!p-auto '
              }`}
            >
              <Box>
                <img
                  onClick={() => {
                    navigate('/');
                  }}
                  src={'/assets/rigLogo.svg'}
                  alt="logo"
                  className={`!shrink-0 cursor-pointer ${
                    isSmall ? 'max-w-[175px]' : 'max-w-[300px]'
                  } relative`}
                />
                {/* {isMedium && <Location textColor="black"/>} */}
              </Box>
              {isLarge == false && <Searchbar />}
              {!isMedium && <Location textColor="black" />}
            </Box>
          </Box>
          <Box alignItems="center" className="max-w-[50%]  flex items-center">
            <Box item container className="flex !w-auto relative">
              {isXLarge == false && (
                <>
                  {' '}
                  <span
                    className={`${
                      isSmall ? 'px-0' : 'px-2'
                    } text-[32px] text-gray-70 cursor-pointer`}
                  >
                   <a href='https://www.tiktok.com/@selllmyrig' target="_blank"><TiktokIcon /></a> 
                  </span>
                  {/* <a href='https://www.facebook.com/profile.php?id=100092651114283&mibextid=LQQJ4d' target="_blank"><FacebookIcon
                    className={`${
                      isSmall ? 'px-0' : 'px-2'
                    } text-[32px] text-gray-70`}
                  /></a> */}
                  {/* <TwitterIcon
                    className={`${
                      isSmall ? 'px-0' : 'px-2'
                    } text-[32px] text-gray-70 cursor-pointer`}
                  /> */}
                  {/* <a href='https://instagram.com/sellmyrigllc?igshid=MzMyNGUyNmU2YQ=='  target="_blank"><InstagramIcon
                    className={`${
                      isSmall ? 'px-0' : 'px-2'
                    } text-[32px] text-gray-70 cursor-pointer`}
                  /> </a> */}
                 {/* <a href='https://www.linkedin.com/company/sell-my-rig/' target="_blank"><LinkedInIcon
                    className={`${
                      isSmall ? 'px-0' : 'px-2'
                    } text-[32px] text-gray-70 cursor-pointer`}
                  /></a>  */}
                </>
              )}
              <FavoriteBorderIcon
                onClick={handleOpenFavourites}
                className="text-[32px] text-secondary-50  cursor-pointer"
              />
              {notifications?.filter((notification) => {
                return notification.read_receipt === false;
              })?.length ? (
                <NotificationsActiveIcon
                  onClick={() => {
                    setShowNotifications(!showNotifications);
                  }}
                  className="text-[32px] px-2 text-primary-50 cursor-pointer"
                />
              ) : (
                <NotificationsNoneIcon
                  onClick={() => {
                    setShowNotifications(!showNotifications);
                  }}
                  className="text-[32px] px-2 text-primary-50 cursor-pointer"
                />
              )}

              <div
                onClick={() => {
                  setShowNotifications(false);
                }}
                className={
                  showNotifications ? 'notifications-container-film' : 'hidden'
                }
              ></div>
              <div
                className={
                  showNotifications
                    ? 'notifications-container scrollable-div'
                    : 'hidden'
                }
              >
                <div className="notification-header">Notifications</div>
                {notifications?.map((notification) => {
                  return (
                    <div
                      className="notification-item"
                      onClick={() => {
                        handleNotification(notification);
                      }}
                    >
                      <div className="notification-content">
                        <p className="title">
                          {notification.title}{' '}
                          <span class="time">
                            {formatDistance(
                              new Date(notification.created_at),
                              new Date(),
                              { addSuffix: true }
                            ).replace('about', '')}
                          </span>
                        </p>
                        <p className="body">{notification.body}</p>
                      </div>
                    </div>
                  );
                })}
                {!notificationsList?.results?.length ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    {NothingToShow()}
                  </div>
                ) : null}
              </div>
            </Box>
            {isLarge === false ? (
              <Box
                className="!w-auto flex  pt-0 md:justify-center  md:pr-0 md:pt-6 lg:pt-0 "
                alignItems="center"
                justifyContent="space-between"
              >
                {isAuth ? (
                  <Profile />
                ) : (
                  <>
                    <Box className="flex" item>
                      <Button
                        style={{
                          hover: { background: 'none !important' },
                          textTransform: 'initial',
                          fontWeight: 500,
                          background: 'none',
                        }}
                        className="mx-2 !bg-none "
                        variant="invisible"
                        onClick={() => {
                          navigate('/login');
                        }}
                      >
                        Log in
                      </Button>
                      <Button
                        style={{ textTransform: 'initial', fontWeight: 500 }}
                        className="!w-full !mx-2"
                        sx={{ background: '#FFC22' }}
                        onClick={() => {
                          navigate('/signup');
                        }}
                        variant="contained"
                      >
                        Sign up
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            ) : (
              <Grid item onClick={() => setOpen(true)}>
                {/* <img src="/assets/menu.svg" className='!text-black' alt="bell" /> */}
                <MenuIcon fontSize="large" />
              </Grid>
            )}
          </Box>
        </Box>
        {isLarge === false && isSubMenu && !showNotifications ? (
          <Grid
            ref={navRef}
            item
            container
            className="bg-primary-50 w-[100%]  h-[50px] justify-center m-auto"
            justifyContent="center"
            alignItems="center"
            columnSpacing={10}
          >
            <SecondaryHeader />
          </Grid>
        ) : (
          <></>
        )}
        <Drawer
          open={open}
          onClose={() => setOpen(false)}
          anchor="right"
          className="w-full"
          sx={{ width: '100vw' }}
        >
          <MobileNav handleClose={() => setOpen(false)} />
        </Drawer>
      </Box>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        sx={{
          width: '100vw',
          '& .MuiDrawer-paper': {
            width: '100vw',
          },
        }}
      >
        <MobileNav handleClose={() => setOpen(false)} />
      </Drawer>
      {/* </Box> */}
      {location?.pathname != '/inventory' && isLarge && (
        <Grid
          justifyContent="center"
          className="py-4"
          md={12}
          item
          lg={12}
          sm={12}
        >
          {' '}
          {isLarge && <Searchbar />}
        </Grid>
      )}
      {!isSubMenu ? (
        <div style={{ height: navHeight + 'px' }} className={`${
          !isMedium ? 'h-auto ' : '!h-0'
        } ${
          !isLarge ? 'h-auto ' : '!h-0'
        }`}></div>
      ) : (
        <div style={{ height: parseInt(fullNavHeight) + 'px' }} className='navHeight'></div>
      )}
    </>
  );
};
export default Navbar;
